import React, { useMemo } from 'react';


import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import ActionToolbar from '../common/ActionToolbar';
import { useTranslation } from 'react-i18next';

const PurchaseAdviceActions = ({
    showSearch = true,
    searchValue = '',
    onSearchChange,
    onRefresh,
    loading = false,
    refreshLoading = false,
    // Filters
    statusValue = '',
    onStatusChange,
    fromDate = '',
    toDate = '',
    onFromDateChange,
    onToDateChange,
}) => {
    const { t } = useTranslation();
    const actions = useMemo(() => [
        {
            key: 'refresh-advice',
            label: t('common.buttons.refresh'),
            icon: faRefresh,
            onClick: onRefresh,
            disabled: refreshLoading,
            variant: 'ghost',
            showLabelBreakpoint: 'sm',
            spinner: refreshLoading,
        },
    ], [onRefresh, refreshLoading]);

    const statusOptions = useMemo(() => [
        { value: '', label: t('purchaseAdvice.actions.filters.all') },
        { value: 'pending', label: t('commonCols.pending') },
        { value: 'ready_for_challan', label: t('commonCols.statusOptions.readyForChallan') },
        { value: 'supervisor_assigned', label: t('commonCols.statusOptions.supervisorAssigned') },
        { value: 'unloading', label: t('commonCols.statusOptions.unloading') },
        { value: 'unloaded', label: t('commonCols.statusOptions.unloaded') },
    ], [t]);

    const filters = useMemo(() => ([
        {
            key: 'from-date',
            type: 'date',
            label: t('commonCols.from'),
            value: fromDate,
            onChange: onFromDateChange,
        },
        {
            key: 'to-date',
            type: 'date',
            label: 'To',
            value: toDate,
            onChange: onToDateChange,
        },
        {
            key: 'status-filter',
            type: 'select',
            label: t('purchaseAdvice.actions.filters.status'),
            value: statusValue,
            options: statusOptions,
            onChange: onStatusChange,
        },
    ]), [statusValue, onStatusChange, statusOptions, fromDate, toDate, onFromDateChange, onToDateChange]);

    return (
        <ActionToolbar
            showSearch={showSearch}
            searchValue={searchValue}
            onSearchChange={onSearchChange}
            searchPlaceholder={t('purchaseAdvice.actions.searchPlaceholder')}
            filters={filters}
            actions={actions}
        />
    );
};

export default PurchaseAdviceActions;
